"use strict";

import Page from "./components/ReservedParkingPassRefundPage.jsx";

export const auth = true;
export const title = "i18n:reservedParkingPassRefundPage.pageTitle";
export const Component = Page;
